export default __webpack_public_path__ + "0aaeb889283c2f8b5e36188b1f1c58e5.png";